<div class="col-auto mr-2">
    <mat-icon [svgIcon]="type"
        [class.invisible]="!type"></mat-icon>
</div>
<div class="col">{{name | translate}}</div>
<div class="col-8 text-right">{{value | bitfNumber:'1.1-1'}} <span *ngIf="!nullOrNaN(value)">{{unit}}</span>
</div>